import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { NavigationMenuItem } from "@/components/ui/navigation-menu";

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearch: (e: React.FormEvent) => void;
}

export const SearchBar = ({ searchQuery, setSearchQuery, handleSearch }: SearchBarProps) => {
  return (
    <NavigationMenuItem className="flex items-center">
      <form onSubmit={handleSearch} className="flex items-center gap-2">
        <div className="relative">
          <Input
            type="search"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-[150px] sm:w-[200px] lg:w-[300px] h-9 bg-background/50 focus:bg-background transition-colors"
          />
        </div>
        <Button 
          type="submit" 
          variant="ghost" 
          size="icon"
          className="h-9 w-9 hover:bg-accent transition-colors"
        >
          <Search className="h-4 w-4" />
        </Button>
      </form>
    </NavigationMenuItem>
  );
};